import { atom } from 'jotai';

export const selectedImagesAtom = atom<string[]>([]); //선택된 사진 배열 상태
export const sendingPhotoArrAtom = atom<File[]>([]);

// credit
export const checkedBoxesAtom = atom({
  termsCondition : false,
  personalInformation : false,
  marketingConstent : false
});
export const SelectedRadiobuttonAtom = atom<string>("option1");
export const photoFormDataAtom = atom<FormData>(new FormData());

